import { gql } from "@apollo/client"

export const QUERY_ALL_REGIONS_AND_LODGES = gql`
  query getAllRegions {
    findRegions {
      name
      country
      code
      lodges {
        name
        code
      }
    }
  }
`
